import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class TermsOfServiceController extends Controller {
  @service currentUser;
  @service pixToast;
  @service router;
  @service intl;
  @service locale;

  // TODO: supprimer avec le feature toggle newPixCertifLegalDocumentsVersioning (ancienne page CGU)
  @tracked isEnglishLocale = this.locale.currentLocale === 'en';

  @action
  async submit() {
    try {
      await this.currentUser.certificationPointOfContact.save({
        adapterOptions: { acceptPixCertifTermsOfService: true },
      });
      this.currentUser.certificationPointOfContact.pixCertifTermsOfServiceStatus = 'accepted';
      this.router.transitionTo('authenticated.sessions');
    } catch {
      this.pixToast.sendErrorNotification({ message: this.intl.t('common.api-error-messages.internal-server-error') });
    }
  }
}
